import Vue from 'vue';
import constData from './config';
import {
  common,
} from '@tencent/ceiba-base-components';
import { isAPP } from './util';
const isApp = () => isAPP() || !!window?.navigator.userAgent.match(/gamehelper/i); // 帮帮判断是否在助手内
let gShareConfig = {};
export default {
  // setAPPShare: async (params) => {
  //   let gShareConfig = params;
  // },
  getFlowRequestExtData: async () => {
    const userId = common.tool.getQueryparams('userId')
     || common.tool.getQueryparams('userid');
    const token = common.tool.getQueryparams('token'); // 新增 token字段 助手登录态token用于校验 助手查询登录天数
    const bbUin = common.tool.getQueryparams('toUin')
     || common.tool.getQueryparams('uin') || 0; // 新增uin字段 便于获取助手uin(qq号,微信助手commonid)
    if (userId && token) {
      return {
        userId,
        token,
        bb_uin: bbUin,
      };
    }
    return {};
  },
  /**
   * 初始化APP环境的分享功能
   */
  initAPPShare: async (shareConfig) => {
    if (!isApp()) {
      return;
    }
    console.log('app initAPPShare', shareConfig);
    // let gShareConfig = shareConfig;
    window.shareIndex = function () {
      if (typeof (window.GameHelper) !== 'undefined' && typeof (window.GameHelper.shareWebPageWithFuntion) !== 'undefined') {
        window.GameHelper.shareWebPageWithFuntion(
          shareConfig?.title || '',
          shareConfig?.desc || '',
          shareConfig?.icon || '',
          shareConfig?.link || window.location.href,
          '1,2,3,4,5,8',
          0,
        );
      }
    };
  },
  isAPP: isApp,
  gotoAPP: async () => {
    console.log('bb gotoAPP');
    if (isApp()) {
      return false;
    }
    const gid = Vue.prototype.$actInfo?.gid || '1261';
    const title = constData?.GAMEINFO[gid]?.title || '掌火助手';
    const msg = `请前往${title}参与活动`;
    Vue.prototype.alert(msg);
  },
  setAPPShare: async (params) => {
    Vue.prototype?.$storeInstance?.mutations?.UPDATE_SHARE_CONFIG(params);
    gShareConfig = params;
  },
  goAPPShare: async (shareConfigParams) => {
    const shareConfig = shareConfigParams || gShareConfig || Vue.prototype?.$storeInstance?.state?.shareConfig;
    const { title, desc, link: url, icon } = shareConfig;
    const type = '1,2,3,4,5,8';
    console.log('goAPPShareUrl', url);
    window?.GameHelper?.shareWebPageWithFuntion(
      title,
      desc,
      icon,
      url,
      type,
      0,
    );
  },

};
